<template lang="pug">
div
  v-row(no-gutters)
    v-col.text-left(v-if="recipientInfo")
      .text-xs.font-semibold To
      .text-xs {Patient name}
      .text-xs (ID number)
      .text-xs {Phone number}
    v-col.text-left
      .mb-2(v-if="receiptNumber")
        .text-xs.font-semibold Receipt no.
        .text-xs {Receipt no}
      template(v-if="receiptDate")
        .text-xs.font-semibold Receipt date.
        .text-xs {Receipt date}
  div.my-4
    div.text-left.text-sm(v-if="paymentDeclaration") Received from {patient name} the sum of {payment} by {payment.method} being payment for the treatment charges.
  template(v-if="receiptInfo" )
    v-data-table.mb-6(:headers="receiptInfoHeaders" :items="receiptInfoItems" hide-default-footer disable-sort dense)
      template(v-slot:header.productItem="{ header }")
        .text-xs.capitalize {{ header.text }}
      template(v-slot:header.quantity="{ header }")
        .text-xs.capitalize {{ header.text }}
      template(v-slot:header.unitPrice="{ header }")
        .text-xs.capitalize {{ header.text }}
      template(v-slot:header.totalPrice="{ header }")
        .text-xs.capitalize {{ header.text }}
      template(v-slot:item.productItem="{ item }")
        td.text-left.text-xs.py-2 {{ item.productItem }}
      template(v-slot:item.quantity="{ item }")
        td.text-right.text-xs.py-2 {{ item.quantity }}
      template(v-slot:item.unitPrice="{ item }")
        td.text-right.text-xs.py-2.px-0 {{ item.unitPrice }}
      template(v-slot:item.totalPrice="{ item }")
        td.text-right.text-xs.py-2.px-0 {{ item.totalPrice }}
  template(v-if="summarizeInfo")
    v-data-table.mb-6(:headers="summarizeInfoHeaders" :items="summarizeInfoItems" hide-default-footer disable-sort dense)
      template(v-slot:header.category="{ header }")
        .text-xs.capitalize {{ header.text }}
      template(v-slot:header.totalAmount="{ header }")
        .text-xs.capitalize {{ header.text }}
      template(v-slot:item.category="{ item }")
        td.text-left.text-xs.py-2 {{ item.category }}
      template(v-slot:item.totalAmount="{ item }")
        td.text-right.text-xs.py-2.px-0 {{ item.totalAmount }}
  div(v-if="receiptInfo || summarizeInfo")
    v-row(no-gutters)
      v-spacer
      v-col(cols="5")
        .text-xs.text-right.font-semibold.mb-1 Subtotal
        .text-xs.text-right.font-semibold.mb-1 Adjustment
        .text-xs.text-right.font-semibold.mb-1 Tax
        .text-xs.text-right.font-semibold Total
      v-col(cols="5")
        .text-xs.text-right.mb-1 {{ 10000 | displayPrice }}
        .text-xs.text-right.mb-1 {{ 0 | displayPrice }}
        .text-xs.text-right.mb-1 {{ 0 | displayPrice }}
        .text-xs.text-right.font-semibold {{ 10000 | displayPrice }}
  document-template-digital-note-preview(v-if="digitalNote")
</template>

<script>
import { mapGetters } from 'vuex'
import DocumentTemplateDigitalNotePreview from '@/components/clinic/document/preview/DocumentTemplateDigitalNotePreview.vue'

export default {
  components: {
    DocumentTemplateDigitalNotePreview
  },
  props: {
    receiptData: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {
      receiptInfoItems: [
        {
          productItem: 'Paracetamol TAB (500mg)',
          quantity: 2,
          unitPrice: '20.00',
          totalPrice: '40.00'
        },
        {
          productItem: 'Clinical consultation',
          quantity: 1,
          unitPrice: '20.00',
          totalPrice: '20.00'
        },
        {
          productItem: 'Cypherol SYRUP (500ml)',
          quantity: 2,
          unitPrice: '20.00',
          totalPrice: '40.00'
        }
      ],
      summarizeInfoItems: [
        {
          category: 'Service',
          totalAmount: '0.00'
        },
        {
          category: 'Procedure',
          totalAmount: '0.00'
        },
        {
          category: 'Investigation',
          totalAmount: '0.00'
        },
        {
          category: 'Consultation',
          totalAmount: '20.00'
        },
        {
          category: 'Medicine',
          totalAmount: '80.00'
        },
        {
          category: 'Document',
          totalAmount: '0.00'
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      currency: 'getCompanyCurrency',
    }),
    receiptInfoHeaders () {
      return [
        { text: 'Item', value: 'productItem', class: 'pr-0 neutral700--text', align: 'start', width: '40%' },
        { text: 'Qty', value: 'quantity', class: 'neutral700--text', align: 'end' },
        { text: `Unit price (${this.currency.symbol})`, value: 'unitPrice', class: 'px-0 neutral700--text', align: 'end' },
        { text: `Total price (${this.currency.symbol})`, value: 'totalPrice', class: 'px-0 neutral700--text', align: 'end' },
      ]
    },
    summarizeInfoHeaders () {
      return [
        { text: 'Category', value: 'category', class: 'pr-0 neutral700--text', align: 'start' },
        { text: `Total amount (${this.currency.symbol})`, value: 'totalAmount', class: 'neutral700--text px-0', align: 'end' },
      ]
    },
    recipientInfo () {
      return this.receiptData[0]?.value ?? null
    },
    receiptNumber () {
      return this.receiptData[1]?.value ?? null
    },
    receiptDate () {
      return this.receiptData[2]?.value ?? null
    },
    paymentDeclaration () {
      return this.receiptData[3]?.value ?? null
    },
    receiptInfo () {
      return this.receiptData[4]?.value ?? null
    },
    digitalNote () {
      return this.receiptData[5]?.value ?? null
    },
    summarizeInfo () {
      return this.receiptData[6]?.value ?? null
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  border-bottom: 1px solid var(--v-neutral700);
  border-top: 1px solid var(--v-neutral700);
}
::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row) {
  border-bottom: none;
  border-top: none;
}
</style>